import(/* webpackMode: "eager" */ "/vercel/path0/app/faucet/page.tsx");
